import Vue from "vue";

export default {
	version: "1.4",
	base_url: "https://textiles-market.com",
	
	set_token: function(newToken) {
		window.localStorage.setItem("token", newToken);
		Vue.http.headers.common["Token"] = newToken;
	},
	get_token: function() {
		return window.localStorage.getItem("token");
	},
	is_logged_in: function() {
		var token = this.get_token();
		return token !== "";
	},
	logout: function(_rights) {
		this.set_token("");
		_rights.clear_rights();
	},
	verify_response: function(response, rights) {
		if (response.body.NotLogged) {
			this.logout(rights);
			return false;
		}
		return true;
	},
	verify_login_and_redirect: function(vueInstance) {
		if (!this.is_logged_in()) {
			vueInstance.$router.push("/");
		}
	}
};
